import { render } from "./free-coupon.html?vue&type=template&id=0ed4cab2&ts=true"
import script from "./free-coupon.vue?vue&type=script&lang=ts"
export * from "./free-coupon.vue?vue&type=script&lang=ts"

import "./free-coupon.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__